<template>
        <div class=" has-text-centered has-text-white scrollableY">
            <div class="container">
                 <div class="bottom20">&nbsp;</div>
                <H1 class="has-text-white is-size-3"><img src="@/assets/img/fourDotsLogo.png" width="24"/> UPGRADE TO PRO <i v-if="$root.app.DEBUG" @click="fill" class="fa fa-arrow-down"></i></H1>
                <div class="limitWidth2 top10 marginAutod has-text-centered">
                   
                    <div class="top30" v-show="!paymentSucceeded">
                        <form class="form has-text-left" v-on:submit.prevent="submit">
                            <h2>Please select from the following plans:</h2>
                            <div class="top20">
                                
                                <div class="columns">
                                   <div class="column is-flex">
                                        <div class="paidPlans" @click="plan = 'monthly'" :class="{selected: plan == 'monthly'}">
                                            <div class="planName"><b>{{plans ? plans[1].name : ''}}</b></div>
                                            <div class="planPrice top10">$<b>{{plans ? plans[1].price : ''}}/{{plans ? plans[1].units : ''}}</b></div>
                                            <div class="top10">&bull; Unlimited bundles</div>
                                            <div >&bull; Unlimited miimus</div>
                                            <div >&bull; Collab bundles</div>
                                            <div >&bull; Hide Ads</div>
                                            <div class="planButtonDiv has-text-centered"><button type="button" class="button is-small is-coolGreen top20" :class="{buttonDisabled: (plans ? plan == plans[1].code : true)}">SELECT</button></div>
                                            <!-- <button v-show="plan != 'monthly'" class="top20 button is-small is-coolGreen">SELECT</button> -->
                                           <!--  <div v-show="plan == 'monthly'" class="top20 has-text-coolGreen"><i class="fa fa-check fa-2x"></i></div> -->
                                        </div>
                                       
                                   </div>
    
                                   <div class="column is-flex">
                                        <div class="paidPlans" @click="plan = 'yearly'" :class="{selected: plan == 'yearly'}">
                                            <div class="bValue has-text-centered">
                                                <i class="fa fa-certificate is-size-4 has-text-coolGreen"></i>
                                                <div class="is-size-7 txt"><b>Best<br>Value</b></div>
                                            </div>
                                            <div class="planName"><b>{{plans ? plans[2].name : ''}}</b></div>
                                            <div class="planPrice top10"><b>${{plans ? plans[2].price : ''}}/{{plans ? plans[2].units : ''}}</b></div>
                                            <div class="top10">&bull; Unlimited bundles</div>
                                        <div >&bull; Unlimited miimus</div>
                                        <div >&bull; Collab bundles</div>
                                        <div >&bull; Hide Ads</div>
                                        <div class="planButtonDiv has-text-centered"><button type="button" class="button is-small is-coolGreen top20" :class="{buttonDisabled: (plans ? plan == plans[2].code : true)}">SELECT</button></div>
                                           <!--  <button v-show="plan != 'yearly'" class="top20 button is-small is-coolGreen">SELECT</button> -->
                                          <!--   <div v-show="plan == 'yearly'" class="top20 has-text-coolGreen"><i class="fa fa-check fa-2x"></i></div> -->
                                        </div>
                                   </div>
                                </div>
                                
                                
                                
                                
                                
                                
                                
                              <!--   <div class="field" v-for="p in paidPlans" :key="p.code">
                                    <input
                                    class="is-coolGreen"
                                    :id="p.code"
                                    type="radio"
                                    name="plan"
                                    :value="p.code"
                                    v-model="plan"
                                    />
                                    <label for="p.code"> {{ p.name }}{{ p.code === 'free' ? '' : ' - $' + p.price + '/' + p.units }}{{ p.recommended ? ' (Best Value)' : ''}}</label>
                                </div> -->
                            </div>
                          
    
                            <div class="limitWidth botMargin" v-show="!declined">
                                <div class="top40">
                                    <div class="is-size-4 has-text-white">
                                        <b>Your Total: ${{ getPlanPrice() }}</b>
                                    </div>
                                    <div class="has-text-white">
                                        This is a subscription charge. Your credit card will automatically be charged this amount every {{ getPlanUnits() }}.
                                    </div>
                                </div>
                                
                                <div class="has-text-weight-bold top20 has-text-white">
                                        Card Info:
                                        <h4 v-if="$root.app.DEBUG">
                                            4242424242424242 (accepted)<br />
                                            4000002500003155 (3d Secure)<br />
                                            4000000000000002 (declined)
                                        </h4>
                                    </div>
                                    
                                    <div class="field top10">
                                        Name on Card:
                                        <input type="text" class="input is-coolGreen billing-field" v-model="planForm.nameOnCard" />
                                    </div>
    
                                    <div class="field">
                                        Card Number:
                                        <div class="stripe-field">
                                            <div id="card-number-element"></div>
                                        </div>
                                    </div>
                                    <div class="field">
                                        Card Expiration:
                                        <div class="stripe-field">
                                            <div id="card-expiry-element"></div>
                                        </div>
                                    </div>
                                    <div class="field">
                                        Card CVC:
                                        <div class="stripe-field">
                                            <div id="card-cvc-element"></div>
                                        </div>
                                    </div>
                                <div id="billingInfo" class="top30">
                                
                                    <div class="has-text-weight-bold top20 has-text-white">
                                        Billing Address:
                                    </div>
    
                                    <div class="field top10" :class="{formError: errors.first('address1')}">
                                        Address:
                                        <input type="text" class="input is-coolGreen billing-field" name="address1" v-validate="'required'" v-model="planForm.address1" />
                                        <p class="help is-danger" >
                                            {{ errors.first('address1') }}
                                        </p>
                                    </div>
    
                                    <div class="field">
                                        <br />
                                        <input type="text" class="input is-coolGreen billing-field" name="address2" v-model="planForm.address2" />
                                    </div>
    
                                    <div class="field" :class="{formError: errors.first('city')}">
                                        City:
                                        <input type="text" class="input is-coolGreen billing-field" name="city" v-validate="'required'" v-model="planForm.city" />
                                        <p class="help is-danger" >
                                            {{ errors.first('city') }}
                                        </p>
                                    </div>
    
                                    <div class="field" :class="{formError: errors.first('state')}">
                                        State:
                                        <input type="text" class="input is-coolGreen billing-field" name="state" v-validate="'required'" v-model="planForm.state" />
                                        <p class="help is-danger" >
                                            {{ errors.first('state') }}
                                        </p>
                                    </div>
    
                                    <div class="field" :class="{formError: errors.first('zip')}">
                                        Zip:
                                        <input type="text" class="input is-coolGreen billing-field" name="zip" v-validate="'required'" v-model="planForm.zip" />
                                        <p class="help is-danger" >
                                            {{ errors.first('zip') }}
                                        </p>
                                    </div>
    
                                    <div class="field" :class="{formError: errors.first('country') }">
                                        Country:<br/>
                                        <div class="select is-coolGreen width100">
                                            <select name="country" class="width100 billing-dropdown"  v-validate="'required'" v-model="planForm.country">
                                                <option disabled value="">Select...</option>
                                                <option v-for="item in countries" :key="item.code" v-bind:value="item.code">{{item.name}}</option>
                                            </select>
                                        </div>
                                        <p class="help is-danger" >
                                            {{ errors.first('country')}}
                                        </p>
                                    </div>
                                  
    
                                    <div class="top20">
                                        <!-- div id="hasGwId" v-if="this.hasGwId">
                                            <div id="ccDiv" class="has-background-light">
                                                Credit Card ending in:  *<span class="has-text-weight-bold">{{info.src.cardNumber}}</span>
                                                <button class="button is-small is-pulled-right" @click="update">UPDATE</button>
                                            </div>
                                            <div class="left10 top10 has-text-white">
                                                <span>{{info.billing.firstName}} {{info.billing.lastName}}</span><br>
                                                <span>{{info.billing.address}}</span><br>
                                                <span>{{info.billing.city}}</span>, <span>{{info.billing.state}}</span>  <span> {{info.billing.zip}}</span><br>
                                                <span>{{info.billing.country | countryFromCode}}</span><br>
                                            </div>
                                        </div>
    
                                        <div id="noGwId" v-if="!this.hasGwId">
                                            
                                        </div -->
    
                                        <button id="submitPayment" class="button is-coolGreen top20" type="submit">SUBMIT PAYMENT</button>
                                        <div class="has-text-danger has-text-weight-bold top10" v-show="showErrorsLine == true">Please correct the errors in the form and submit again.</div>
                                        <div class="has-text-danger has-text-weight-bold top10" v-show="stripeError">{{ stripeError }}</div>
                                    </div>
                                    <div class="bottom80"></div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
    
                <div v-show="paymentSucceeded">
                    <div class="has-text-white">
                        <div class="is-size-3 top40">Payment Successful!</div> <br>
                       
                        We hope you enjoy your new plan!<br><br>
    
                        If you have any questions, please contact us.<br><br><br><br>
                    </div>
                </div>
                <div v-show="declined">
                    <div class="has-text-white top40">
                        <div class="is-size-3">Oops! Something went wrong!</div> <br>
                        
                        We were unable to charge your credit card. Please update your payment info <b class="pointerCursor" @click="$router.push('/pmtsrc')">here</b>.  Once you have done so we will attempt the charge again.<br><br>
    
                        Your subscription has been created but is pending payment. We will not ship any products until a valid payment source is provided. Subscription ID: <b>{{subsId}}</b><br><br>
    
                        If you have any questions, please contact us.<br><br><br><br>
                    </div>
                </div>
            </div>
            <footerdiv class="top160"></footerdiv>
        </div>
</template>

<script>

import countries from '../static/countries.js'
import { AZEventBus } from '../components/AZEventBus.js';
import Footerdiv from '../components/Footer.vue'
let loadStripe;

export default {
    components: {Footerdiv},
    data: function(){
        var planForm = {
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            country: '',
            nameOnCard: this.$root.app.userAttrs.given_name + ' ' + this.$root.app.userAttrs.family_name
        }

        return{
            // info: {src: {cardNumber: 4545}, billing: {firstName: 'First', lastName: "Last", address: 'Street Name', city: 'City', state: 'State', zip: 'Zip', country: 'US'}},
            countries,
            // total: 3.19, //this.$root.app.checkoutTotal[0],
            // hasGwId: true,//this.$root.app.checkoutTotal[1],
            // az: az,
            showErrorsLine: false,
            // dl: '',
            declined: false,
            subsId: '',
            inited: false,

            planForm: planForm,
            plans: null,
            plan: null,
            paymentSucceeded: false,

            stripe: null,
            stripeError: null,

        }
    },
    filters: {
        countryFromCode: function (value) {
            if (!value) return '';
            value = value.toString();
            for(var i=0; i < countries.length; i++){
                if(value == countries[i].code){
                    return countries[i].name;
                }
            }
            return ''
        }
    },
    computed: {
        paidPlans: function() {
            if (this.plans != null) {
                if (!this.hasUpgraded()) {
                    return this.plans.filter(plan => plan.price > 0);
                } else {
                    return this.plans;
                }
            }
            return [];
        }
    },
  
    mounted: async function(){
        const self = this

        // Load plans.
        self.$root.app.apiClient.get('open/confirm/plans', {}, (plans) => {
            self.plans = plans;
            for (let p of plans) {
                if (p.recommended) {
                    this.plan = p.code;
                }
            }
        }, (e) => {
            console.log(e);
        });

        let stripeStyle = {
            base: {
                color: '#fff',
                fontSize: '16px',
                '::placeholder': {
                    color: '#888'
                },
                backgroundColor: '#333'
            }
        }

        // Initialize Stripe
        if(!this.$root.app.inApp){

            if (!loadStripe) {
                loadStripe = (await import('@stripe/stripe-js')).loadStripe;
            }
            
            this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUB_KEY);
            this.elements = this.stripe.elements();
            

            this.cardNumberElement = this.elements.create('cardNumber', {
                style: stripeStyle
            });
            this.cardNumberElement.mount('#card-number-element');

            this.cardExpiryElement = this.elements.create('cardExpiry', {
                style: stripeStyle
            });
            this.cardExpiryElement.mount('#card-expiry-element');

            this.cardCvcElement = this.elements.create('cardCvc', {
                style: stripeStyle
            });
            this.cardCvcElement.mount('#card-cvc-element');
        }
        
    },
    methods:{
        submit: function() {
            var self = this
            this.$validator.validateAll().then(async success => {
                if (success) {
                    let price = this.getPlanPrice();

                    self.showErrorsLine = false;

                    if (price > 0) {

                        az.addRemSpinner(true, 'id', 'submitPayment');
                        self.$root.app.apiClient.post('open/subscribe', {
                            sub: self.$root.app.userAttrs.sub,
                            planCode: this.plan
                        }, (res) => {

                            // Success
                            let secret = res.secret;
                            this.stripe.confirmCardPayment(res.secret, {
                                payment_method: {
                                    card: this.cardNumberElement,
                                    billing_details: {
                                        name: this.planForm.nameOnCard,
                                        address: {
                                            line1: this.planForm.address1,
                                            line2: this.planForm.address2,
                                            city: this.planForm.city,
                                            state: this.planForm.state,
                                            postal_code: this.planForm.zip,
                                            country: this.planForm.country,
                                        },
                                    }
                                }
                            }).then(async result => {
                                az.addRemSpinner(false, 'id', 'submitPayment');
                                // TODO
                                if (result.error) {
                                    this.stripeError = result.error.message;
                                } else {
                                    document.getElementById('routerView').scrollTo(0, 0);
                                    self.paymentSucceeded = true;
                                    self.$root.app.userAttrs.hasUpgraded = true;
                                    self.$root.app.userAttrs.bundleLimit = this.getPlanBundleLimit();
                                    self.$root.app.userAttrs.cardLimit = this.getPlanCardLimit();
                                }
                            });

                        }, (e) => {

                            // Failure
                            console.log(e);

                        });

                    } else {
                        // This should never happen.
                    }

                } else {
                    self.showErrorsLine = true;
                    self.stripeError = null;
                }
            })
            
        },
        getPlanPrice() {
            let price = null;

            if (this.plans != null) {
                for (let p of this.plans) {
                    if (p.code == this.plan) {
                        price = p.price;
                        break;
                    }
                }
            }

            return price != null ? parseFloat(price) : '';
        },
        getPlanUnits() {
            let units = null;

            if (this.plans != null) {
                for (let p of this.plans) {
                    if (p.code == this.plan) {
                        units = p.units;
                        break;
                    }
                }
            }

            return units != null ? units : 'month';
        },
        getPlanBundleLimit() {
            let bundleLimit = null;

            if (this.plans != null) {
                for (let p of this.plans) {
                    if (p.code == this.plan) {
                        bundleLimit = p.bundleLimit;
                        break;
                    }
                }
            }

            return bundleLimit != null ? bundleLimit : 20;
        },
        getPlanCardLimit() {
            let cardLimit = null;

            if (this.plans != null) {
                for (let p of this.plans) {
                    if (p.code == this.plan) {
                        cardLimit = p.cardLimit;
                        break;
                    }
                }
            }

            return cardLimit != null ? cardLimit : 20;
        },
        hasUpgraded() {
            return this.$root.app.userAttrs.hasUpgraded === true;
        },
        fill() {
            this.planForm.address1 = '123 Main St.';
            this.planForm.city = 'Denver';
            this.planForm.state = 'CO';
            this.planForm.zip = '12345';
            this.planForm.country = 'US';
            this.planForm.nameOnCard = 'John Smith';
        }
    }
}
</script>
